import type App from "../index";
import { ScrollDirection, ScrollHandler } from "../classes/scroll-manager";
import { getEl, getEls } from '../helpers';
import anime from 'animejs';
import Globals from "../classes/globals";


export default class BackToTop
{

    constructor(app: App) {
		const els = getEls("#slb-report .back-to-top");

		els.forEach((element) => {
			element.addEventListener('click', (e) => {
				e.preventDefault();
				let thisY = window.scrollY;
				const tween = {
					value: thisY,
				};
				anime({
					targets: tween,
					value: [thisY, 0],
					easing: "easeInOutQuad",
					duration: 5000,
					update: () => {
						window.scrollTo({behavior: "instant", top: tween.value});
					}
				});
			});
		});

	}

}
